import { CreateMacroGroupsFormComponent } from './create-macro-groups-form/create-macro-groups-form.component';
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@app/core";
import { NgModule } from '@angular/core';

const routes: Routes = [
  { path: '', canActivate: [ AuthenticationGuard ], component: CreateMacroGroupsFormComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MacroGroupRoutingModule { }
